const videoHelper = require('../utils/videoUtils');
const utils = require('../utils');

const bannerVideoEvent = () => {
    const bannerVideoExist = $('.banner.video-trigger');
    const docBody = $('body');
    let triggerElement = null;

    if (bannerVideoExist.length) {
        docBody.on('click', '.banner.video-trigger', (e) => {
            const target = $(e.currentTarget);
            triggerElement = e.currentTarget;
            const embedUrl = videoHelper.getVideoUrl(target.data('videourl'));
            let htmlString = '';
            if (embedUrl) {
                htmlString = `<!-- Modal -->
                    <div class="modal fade" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="videoModal" aria-hidden="true">
                        <div class="modal-dialog big quick-view-dialog">
                            <div class="modal-content">
                                <button type="button" class="close no-btn icon-cross-line" data-dismiss="modal" mcclane-data="close-generic-popup" aria-label="${utils.getCloseLabel()}"></button>
                                <div class="modal-body pt-5 pt-lg-0">
                                    <div class="embed-responsive embed-responsive-16by9">
                                        <iframe class="embed-responsive-item" src="${embedUrl}" title="videoModal" id="video" allowscriptaccess="always" allow="autoplay"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;
            }

            docBody.append(htmlString);

            $('#videoModal').on('hidden.bs.modal', () => {
                $('.embed-responsive-item').attr('src', '');

                if (triggerElement) {
                    triggerElement.focus();
                }
            });

            $('#videoModal').modal();
        });

        docBody.on('keydown', '.banner.video-trigger', (e) => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                $(e.currentTarget).trigger('click');
            }
        });

        docBody.on('click', '.close-video, #videoModal', () => {
            $('#videoModal').modal('hide').remove();
            $('.modal-backdrop').remove();
            docBody.removeClass('no-overflow');
            docBody.removeClass('modal-open');
            if (triggerElement) {
                    triggerElement.focus();
            }
        });
    }
};

module.exports = {
    bannerVideoEvent,
};